import React from 'react';

const Titile = () => {
    return (
        <div className='mt-8'><h1 className='text-5xl  m-auto text-center'>CONTACT US</h1>
        <div className='m-auto w-64 mt-3 mb-2 h-1 bg-primary'></div>
        </div>
    );
};

export default Titile;